import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	previousProjectKeysLabel: {
		id: 'project-details.previous-project-keys-label',
		defaultMessage: 'Previous project keys',
		description: 'Label for the released historical project keys field',
	},
	selectPlaceholderLabel: {
		id: 'project-details.previous-project-keys-placeholder-label',
		defaultMessage: 'No previous project keys remaining',
		description: 'Placeholder label for the released historical project keys field',
	},
	infoTriggerLabel: {
		id: 'project-details.previous-project-keys-info-trigger-label',
		defaultMessage: 'More about project keys',
		description: 'Label for the info trigger for the released historical project keys field',
	},
	JsmProjectDisabledMessage: {
		id: 'project-details.previous-project-keys-info-jsm-disable-message',
		defaultMessage:
			'Removing previous projects keys is currently not available for Jira Service Management projects.',
		description:
			'Message for warning specifying JSM projects cannot currently release project keys',
	},
});
